// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/room_specifications.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/feature/hotel/room_specifications.proto.
 */
export const file_proto_model_feature_hotel_room_specifications = /*@__PURE__*/
  fileDesc("CjNwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL3Jvb21fc3BlY2lmaWNhdGlvbnMucHJvdG8SBmNhcm1lbiKXAQoSUm9vbVNwZWNpZmljYXRpb25zEhAKCHNpemVfc3FtGAEgASgBEhEKCXNpemVfc3FmdBgCIAEoARIRCgliYXRocm9vbXMYAyABKAUSDQoFZmxvb3IYBCABKAUSFQoNcm9vbV9jYXRlZ29yeRgFIAEoCRIjCgl2aWV3X3R5cGUYBiABKA4yEC5jYXJtZW4uVmlld1R5cGUqwQEKCFZpZXdUeXBlEhkKFVZJRVdfVFlQRV9VTlNQRUNJRklFRBAAEhMKD1ZJRVdfVFlQRV9PQ0VBThABEhIKDlZJRVdfVFlQRV9DSVRZEAISFgoSVklFV19UWVBFX01PVU5UQUlOEAMSFAoQVklFV19UWVBFX0dBUkRFThAEEhIKDlZJRVdfVFlQRV9QT09MEAUSFwoTVklFV19UWVBFX0NPVVJUWUFSRBAGEhYKElZJRVdfVFlQRV9JTlRFUklPUhAHQjZaNGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvaG90ZWxiBnByb3RvMw");

/**
 * Describes the message carmen.RoomSpecifications.
 * Use `create(RoomSpecificationsSchema)` to create a new message.
 */
export const RoomSpecificationsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_room_specifications, 0);

/**
 * Describes the enum carmen.ViewType.
 */
export const ViewTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_room_specifications, 0);

/**
 * @generated from enum carmen.ViewType
 */
export const ViewType = /*@__PURE__*/
  tsEnum(ViewTypeSchema);

